import { render, staticRenderFns } from "./ProjectChart.vue?vue&type=template&id=39b15ca0&scoped=true"
import script from "./ProjectChart.vue?vue&type=script&lang=ts"
export * from "./ProjectChart.vue?vue&type=script&lang=ts"
import style0 from "./ProjectChart.vue?vue&type=style&index=0&id=39b15ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b15ca0",
  null
  
)

export default component.exports